import * as Styled from './styles';
import Interweave from 'interweave';
export const TextContainer = ({ title, body }) => {
    return (
        <Styled.Container>
            <Interweave content={`<h5>${title}</h5><p>${body}</p>`}/>
        </Styled.Container>
    );
};